import { IFailedTempPlannedPortfolio } from './../../models/plannedPortfolios';
import { Subscription } from 'rxjs';
import { ModelPortfoliosFacade } from 'src/app/store/model-portfolios/facade/model-portfolios.facade';
import { IPlannedPortfolio, IModelPortfolioSubscription } from 'src/app/models/plannedPortfolios';
import { IModelPortfolio } from 'src/app/models/modelPortfolios';
import { Injectable, OnDestroy } from '@angular/core';
import resolveConfig from "tailwindcss/resolveConfig";
import { theme } from '../../../../tailwind.config.js';
import { AssetAllocation } from "../../models/assetAllocation";
@Injectable({ providedIn: 'root' })
export class ModelPortfolioutilsService implements OnDestroy {

    failedTempPlannedPortfolios$: Subscription;
    failedTempPlannedPortfolios: IFailedTempPlannedPortfolio[];

    rebalancedPlannedPortfolios$: Subscription;
    rebalancedPlannedPortfolios: IPlannedPortfolio[];

    public theme = resolveConfig(theme);
    public warningOrange: string = this.theme.extend.colors['warning-orange']['500'];
    public actionBlue: string = this.theme.extend.colors['action-blue'];
    public primaryTextBlack: string = this.theme.extend.colors['primary-2'];

    constructor(private modelPortfoliosFacade: ModelPortfoliosFacade) {
        this.failedTempPlannedPortfolios$ = this.modelPortfoliosFacade.failedTempPlannedPortfolios$.subscribe((failedTempPlannedPortfolios: IFailedTempPlannedPortfolio[]) => {
            this.failedTempPlannedPortfolios = failedTempPlannedPortfolios;
        });
        this.rebalancedPlannedPortfolios$ = this.modelPortfoliosFacade.selectRebalancedPlannedPortfolios$.subscribe((rebalancedPlannedPortfolios: IPlannedPortfolio[]) => {
            this.rebalancedPlannedPortfolios = rebalancedPlannedPortfolios;
        });
    }

    public getFailedTempPlannedPortfolios(newTempPlannedPortfolios: IPlannedPortfolio[]): IFailedTempPlannedPortfolio[] {
        const newFailedTempPlannedPortfolios: IFailedTempPlannedPortfolio[] = newTempPlannedPortfolios.filter((plannedPortfolio: IPlannedPortfolio) => {
            return plannedPortfolio.rebalancingErrorMessage !== null && plannedPortfolio.rebalancingErrorMessage !== "";
        }).map((plannedPortfolio: IPlannedPortfolio) => {
            return {
                id: plannedPortfolio.subscriptionId,
                errorMessage: plannedPortfolio.rebalancingErrorMessage
            };
        });

        const newSucceededTempPlannedPortfolios: IFailedTempPlannedPortfolio[] = newTempPlannedPortfolios.filter((plannedPortfolio: IPlannedPortfolio) => {
            return plannedPortfolio.rebalancingErrorMessage === null || plannedPortfolio.rebalancingErrorMessage === "";
        }).map((plannedPortfolio: IPlannedPortfolio) => {
            return {
                id: plannedPortfolio.subscriptionId,
                errorMessage: plannedPortfolio.rebalancingErrorMessage
            };
        });

        // First, filter out the portfolios (subscriptionIds) that previously failed, but succeeded this time. Then, add the newly failed.
        // Then, in the second function, undouble the resulting array
        const filteredFailedTempPlannedPortfolios = this.failedTempPlannedPortfolios.filter((val: IFailedTempPlannedPortfolio) => {
            return !newSucceededTempPlannedPortfolios.find((newSucceededTempPlannedPortfolio: IFailedTempPlannedPortfolio) => newSucceededTempPlannedPortfolio.id === val.id);
        }).concat(newFailedTempPlannedPortfolios);

        const finalFailedTempPlannedPortfolios = filteredFailedTempPlannedPortfolios.filter((value, index, self) => {
            return self.findIndex((selfValue: IFailedTempPlannedPortfolio) => value.id === selfValue.id) === index;
        });

        return finalFailedTempPlannedPortfolios;
    }

    public getFailedRebalancedPorfolios(modelPorfolio: IModelPortfolio) {
        const tempPlannedPortfolios: IPlannedPortfolio[] = modelPorfolio.subscriptions
            .map((subscription: IModelPortfolioSubscription) => {
                return {
                    id: subscription.id,
                    rebalancingErrorMessage: subscription.rebalancingErrorMessage,
                    modelPortfolioId: subscription.modelPortfolioId,
                    subscriptionId: subscription.id,
                    portfolioId: subscription.portfolioId,
                    positions: null,
                };
            });
        return this.getFailedTempPlannedPortfolios(tempPlannedPortfolios);
    }

    public addTempPlannedPortfolios(newPlannedPortfolios: IPlannedPortfolio[]) {
        const concattedPlannedPortfolios = this.rebalancedPlannedPortfolios.concat(newPlannedPortfolios);
        const newRebalancedPlannedPortfolios = concattedPlannedPortfolios.filter((value, index, self) => {
            return self.findIndex((selfValue: IPlannedPortfolio) => value.subscriptionId === selfValue.subscriptionId) === index;
        });
        return newRebalancedPlannedPortfolios;
    }


    /**
     * Determines the color code for the asset classification group.
     *
     * @param selectedPortfolioPositions - The selected portfolio positions.
     * @param assetAllocations  - The asset allocations data.
     * @param {number} [assetClassificationId] - The ID of the asset classification.
     * @return {string} The color code corresponding to the computed asset allocation target.
     */
    public computeAssetAssetClassificationColor(selectedPortfolioPositions: any, assetAllocations: AssetAllocation[], assetClassificationId?: number): string{
        const assetAllocationTargetState = this.computeAssetAllocationTargetState(selectedPortfolioPositions, assetAllocations, assetClassificationId);

        // Return blue if securities are ABOVE the asset allocation target
        if (assetAllocationTargetState > 0)
            return this.actionBlue;

        // Return red if below
        if (assetAllocationTargetState < 0)
            return this.warningOrange;

        // Or return black if no change
        return this.primaryTextBlack;
    }

    /**
     * Computes the classification title based on the asset allocation target state.
     *
     * @param selectedPortfolioPositions - The selected portfolio positions.
     * @param assetAllocations - The asset allocations data.
     * @param {number} [assetClassificationId] - The ID of the asset classification.
     * @return {string} - The classification title to display
     */
    public computeAssetAssetClassificationTitle(selectedPortfolioPositions: any, assetAllocations: AssetAllocation[], assetClassificationId?: number): string{
        const assetAllocationTargetState = this.computeAssetAllocationTargetState(selectedPortfolioPositions, assetAllocations, assetClassificationId);

        // Return blue if securities are ABOVE the asset allocation target
        if (assetAllocationTargetState > 0)
            return "The sum of the security target weights is above the asset allocation target weight";

        // Return red if below
        if (assetAllocationTargetState < 0)
            return "The sum of the security target weights is below the asset allocation target weight";

        // Or return black if no change
        return "The sum of the security target weights matches the asset allocation target weight";
    }

    /**
     * Computes the state of asset allocation for a given asset classification ID.
     * - `-1` if the total target weight is below the asset allocation target.
     * - `0` if the total target weight is equal to the asset allocation target.
     * - `1` if the total target weight is above the asset allocation target.
     *
     * @param selectedPortfolioPositions - The selected portfolio positions.
     * @param assetAllocations - The asset allocations data.
     * @param {number} [assetClassificationId] - The ID of the asset classification.
     * @return {number} - Returns `-1`, `0`, or `1`
     */
    private computeAssetAllocationTargetState(selectedPortfolioPositions: any, assetAllocations: AssetAllocation[], assetClassificationId?: number): number {
        if (!assetClassificationId || !assetAllocations)
            return 0;

        // Sum the total target weights under the asset classification
        let totalTargetWeight = 0;
        for (const position of selectedPortfolioPositions) {
            if (position.assetClassificationId === assetClassificationId) {
                totalTargetWeight += position.targetWeight;
            }
        }

        // Get the asset allocation target
        const assetAllocationTarget = this.getAssetAllocationTarget(assetAllocations, assetClassificationId);

        // round to 4dp
        const totalTargetWeightRounded = Math.round(totalTargetWeight * 10000) / 10000;
        const assetAllocationTargetRounded = Math.round(assetAllocationTarget * 10000) / 10000;

        // If the sum of targets is BELOW the asset allocation target, return -1.
        if (totalTargetWeightRounded < assetAllocationTargetRounded)
            return -1;

        // If the sum of targets is ABOVE the asset allocation target, return 1.
        if (totalTargetWeightRounded > assetAllocationTargetRounded)
            return 1;

        // If they're equal, return 0
        return 0;
    }

    public getAssetAllocationTarget(assetAllocations: AssetAllocation[], assetClassificationId?: number): number | null {
        if (!assetClassificationId || !assetAllocations)
            return null;

        return assetAllocations.find(assetAllocation => assetAllocation.assetClassificationId === assetClassificationId)?.targetAllocation;
    }

    public getAssetAllocationToleranceRange(assetAllocations: AssetAllocation[], assetClassificationId?: number): string {
        if (!assetClassificationId || !assetAllocations)
            return null;

        let assetClassInfo = assetAllocations.find(assetAllocation => assetAllocation.assetClassificationId === assetClassificationId);
        if (assetClassInfo) {
            return ((assetClassInfo.targetAllocation - assetClassInfo.lowerLimit) * 100).toFixed(2) + '% - ' + ((assetClassInfo.targetAllocation + assetClassInfo.upperLimit) * 100).toFixed(2) + '%';
        }
        return "";
    }

    public assetAllocationOutsideToleranceRange(assetAllocations: AssetAllocation[], assetClassificationId: any, securityGroupCurrentTotal: any) {
        if (!assetClassificationId || !securityGroupCurrentTotal || !assetAllocations)
            return false;

        //Check if the asset allocation is outside the tolerance range
        const assetClassInfo = assetAllocations.find(assetAllocation => assetAllocation.assetClassificationId === assetClassificationId);
        if (assetClassInfo) {
            const lowerLimit = assetClassInfo.targetAllocation - assetClassInfo.lowerLimit;
            const upperLimit = assetClassInfo.targetAllocation + assetClassInfo.upperLimit;
            return securityGroupCurrentTotal < lowerLimit || securityGroupCurrentTotal > upperLimit;
        }
        return false;
    }

    public getAssetAllocationLowerTolerance(assetAllocations: AssetAllocation[], assetClassificationId?: number): number | null {
        if (!assetClassificationId || !assetAllocations)
            return null;

        return assetAllocations.find(assetAllocation => assetAllocation.assetClassificationId === assetClassificationId)?.lowerLimit;
    }

    public getAssetAllocationUpperTolerance(assetAllocations: AssetAllocation[], assetClassificationId?: number): number | null {
        if (!assetClassificationId || !assetAllocations)
            return null;

        return assetAllocations.find(assetAllocation => assetAllocation.assetClassificationId === assetClassificationId)?.upperLimit;
    }

    ngOnDestroy() { }
}
